import { Link } from 'react-router-dom';
import Navbar from '../../../../components/feature/Navbar';
import Footer from '../../../../components/feature/Footer';

export default function WindowsAutopilotPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="pt-32 pb-16 px-6">
        <div className="max-w-4xl mx-auto">
          <Link 
            to="/intune" 
            className="inline-flex items-center text-sm text-gray-600 hover:text-orange-600 mb-6 transition-colors"
          >
            <i className="ri-arrow-left-line mr-2"></i>
            Intune'a Geri Dön
          </Link>
          
          <div className="mb-8">
            <span className="inline-block px-4 py-1 bg-orange-100 text-orange-700 rounded-full text-sm font-medium mb-4">
              Microsoft Intune
            </span>
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Windows Autopilot: Sıfır Dokunuş Cihaz Dağıtımı
            </h1>
            <div className="flex items-center text-gray-600 text-sm">
              <i className="ri-calendar-line mr-2"></i>
              <span>9 Haziran 2025</span>
              <span className="mx-3">•</span>
              <i className="ri-time-line mr-2"></i>
              <span>12 dakika okuma</span>
            </div>
          </div>

          <img 
            src="https://public.readdy.ai/ai/img_res/6f499916a956c0ad6e1fb3a281ebd3a5.jpg"
            alt="Windows Autopilot"
            className="w-full h-96 object-cover rounded-2xl mb-12"
          />
        </div>
      </section>

      {/* Article Content */}
      <article className="pb-20 px-6">
        <div className="max-w-4xl mx-auto">
          <div className="prose prose-lg max-w-none">
            
            {/* Introduction */}
            <div className="mb-12">
              <p className="text-xl text-gray-700 leading-relaxed mb-6">
                Geleneksel Windows cihaz dağıtımı, IT ekiplerinin her cihazı manuel olarak yapılandırmasını gerektiriyordu. Windows Autopilot, bu süreci tamamen otomatikleştirerek "sıfır dokunuş" dağıtım deneyimi sunar. Cihazlar doğrudan üreticiden kullanıcıya gönderilir ve ilk açılışta otomatik olarak yapılandırılır.
              </p>
            </div>

            {/* How It Works */}
            <section className="mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Autopilot Nasıl Çalışır?</h2>
              
              <div className="bg-gradient-to-br from-orange-50 to-red-50 rounded-2xl p-8 mb-8">
                <div className="space-y-6">
                  <div className="flex items-start">
                    <div className="w-12 h-12 bg-orange-600 text-white rounded-xl flex items-center justify-center mr-4 flex-shrink-0 font-bold text-lg">
                      1
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-gray-900 mb-2">Cihaz Kaydı</h3>
                      <p className="text-gray-700">
                        OEM (Dell, HP, Lenovo vb.) veya distribütör, cihazın donanım kimliğini (Hardware Hash) Autopilot servisine kaydeder. Bu işlem satın alma sırasında otomatik yapılabilir.
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="w-12 h-12 bg-orange-600 text-white rounded-xl flex items-center justify-center mr-4 flex-shrink-0 font-bold text-lg">
                      2
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-gray-900 mb-2">Profil Ataması</h3>
                      <p className="text-gray-700">
                        IT yöneticisi, Intune'da Autopilot profili oluşturur ve kayıtlı cihazlara atar. Profil, cihazın nasıl yapılandırılacağını belirler.
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="w-12 h-12 bg-orange-600 text-white rounded-xl flex items-center justify-center mr-4 flex-shrink-0 font-bold text-lg">
                      3
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-gray-900 mb-2">Kullanıcı Deneyimi</h3>
                      <p className="text-gray-700">
                        Kullanıcı cihazı açar, internet bağlantısı kurar ve şirket kimlik bilgileri ile oturum açar. Cihaz otomatik olarak Entra ID'ye katılır ve Intune'a kaydolur.
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="w-12 h-12 bg-orange-600 text-white rounded-xl flex items-center justify-center mr-4 flex-shrink-0 font-bold text-lg">
                      4
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-gray-900 mb-2">Otomatik Yapılandırma</h3>
                      <p className="text-gray-700">
                        Intune politikaları, uygulamalar ve ayarlar otomatik olarak cihaza uygulanır. Kullanıcı hiçbir teknik bilgiye ihtiyaç duymadan hazır cihaza kavuşur.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* Deployment Scenarios */}
            <section className="mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Dağıtım Senaryoları</h2>
              
              <div className="space-y-6">
                <div className="border-2 border-gray-200 rounded-2xl p-8 hover:border-orange-600 transition-colors">
                  <div className="flex items-start mb-4">
                    <div className="w-14 h-14 bg-orange-100 rounded-xl flex items-center justify-center mr-4 flex-shrink-0">
                      <i className="ri-user-line text-3xl text-orange-600"></i>
                    </div>
                    <div>
                      <h3 className="text-2xl font-bold text-gray-900 mb-2">User-Driven Mode</h3>
                      <p className="text-gray-600 mb-4">
                        En yaygın senaryo. Kullanıcı cihazı açar ve kendi kimlik bilgileri ile kurulumu tamamlar.
                      </p>
                    </div>
                  </div>

                  <div className="bg-gray-50 rounded-xl p-6 mb-4">
                    <h4 className="font-bold text-gray-900 mb-3">Kullanım Durumları:</h4>
                    <ul className="space-y-2 text-gray-700">
                      <li className="flex items-start">
                        <i className="ri-check-line text-orange-600 mr-2 mt-1"></i>
                        <span>Yeni çalışan onboarding</span>
                      </li>
                      <li className="flex items-start">
                        <i className="ri-check-line text-orange-600 mr-2 mt-1"></i>
                        <span>Uzak çalışanlar için cihaz gönderimi</span>
                      </li>
                      <li className="flex items-start">
                        <i className="ri-check-line text-orange-600 mr-2 mt-1"></i>
                        <span>Cihaz yenileme projeleri</span>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="border-2 border-gray-200 rounded-2xl p-8 hover:border-amber-600 transition-colors">
                  <div className="flex items-start mb-4">
                    <div className="w-14 h-14 bg-amber-100 rounded-xl flex items-center justify-center mr-4 flex-shrink-0">
                      <i className="ri-robot-line text-3xl text-amber-600"></i>
                    </div>
                    <div>
                      <h3 className="text-2xl font-bold text-gray-900 mb-2">Self-Deploying Mode</h3>
                      <p className="text-gray-600 mb-4">
                        Kullanıcı müdahalesi olmadan tamamen otomatik kurulum. Paylaşımlı cihazlar ve kiosk modları için ideal.
                      </p>
                    </div>
                  </div>

                  <div className="bg-gray-50 rounded-xl p-6 mb-4">
                    <h4 className="font-bold text-gray-900 mb-3">Kullanım Durumları:</h4>
                    <ul className="space-y-2 text-gray-700">
                      <li className="flex items-start">
                        <i className="ri-check-line text-amber-600 mr-2 mt-1"></i>
                        <span>Paylaşımlı cihazlar (toplantı odaları, laboratuvarlar)</span>
                      </li>
                      <li className="flex items-start">
                        <i className="ri-check-line text-amber-600 mr-2 mt-1"></i>
                        <span>Kiosk modları (bilgi ekranları, self-servis terminallar)</span>
                      </li>
                      <li className="flex items-start">
                        <i className="ri-check-line text-amber-600 mr-2 mt-1"></i>
                        <span>Dijital tabela cihazları</span>
                      </li>
                    </ul>
                  </div>

                  <div className="bg-gray-900 rounded-lg p-4 overflow-x-auto">
                    <pre className="text-sm text-gray-100">
{`# Self-Deploying Süreci
1. IT teknisyeni cihazı açar
2. Autopilot başlar, "Provisioning" seçeneği görünür
3. Teknisyen provisioning'i başlatır
4. Tüm uygulamalar ve politikalar yüklenir
5. Teknisyen cihazı kapatır ve kullanıcıya gönderir
6. Kullanıcı açar, sadece oturum açar, hazır!`}
                    </pre>
                  </div>
                </div>

                <div className="border-2 border-gray-200 rounded-2xl p-8 hover:border-red-600 transition-colors">
                  <div className="flex items-start mb-4">
                    <div className="w-14 h-14 bg-red-100 rounded-xl flex items-center justify-center mr-4 flex-shrink-0">
                      <i className="ri-tools-line text-3xl text-red-600"></i>
                    </div>
                    <div>
                      <h3 className="text-2xl font-bold text-gray-900 mb-2">Pre-Provisioning (White Glove)</h3>
                      <p className="text-gray-600 mb-4">
                        IT veya partner, cihazı kullanıcıya teslim etmeden önce ön-yapılandırır. Kullanıcı deneyimi çok hızlı olur.
                      </p>
                    </div>
                  </div>

                  <div className="bg-gray-50 rounded-xl p-6 mb-4">
                    <h4 className="font-bold text-gray-900 mb-3">Kullanım Durumları:</h4>
                    <ul className="space-y-2 text-gray-700">
                      <li className="flex items-start">
                        <i className="ri-check-line text-red-600 mr-2 mt-1"></i>
                        <span>Yönetici ve C-level cihazları (hızlı hazır olma)</span>
                      </li>
                      <li className="flex items-start">
                        <i className="ri-check-line text-red-600 mr-2 mt-1"></i>
                        <span>Büyük uygulamaların ön-yüklenmesi</span>
                      </li>
                      <li className="flex items-start">
                        <i className="ri-check-line text-red-600 mr-2 mt-1"></i>
                        <span>Özel yapılandırma gerektiren cihazlar</span>
                      </li>
                    </ul>
                  </div>

                  <div className="bg-gray-900 rounded-lg p-4 overflow-x-auto">
                    <pre className="text-sm text-gray-100">
{`# White Glove Süreci
1. IT teknisyeni cihazı açar
2. Autopilot başlar, "Provisioning" seçeneği görünür
3. Teknisyen provisioning'i başlatır
4. Tüm uygulamalar ve politikalar yüklenir
5. Teknisyen cihazı kapatır ve kullanıcıya gönderir
6. Kullanıcı açar, sadece oturum açar, hazır!`}
                    </pre>
                  </div>
                </div>
              </div>
            </section>

            {/* Hardware Requirements */}
            <section className="mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Donanım Gereksinimleri</h2>
              
              <div className="grid md:grid-cols-2 gap-6 mb-8">
                <div className="bg-white border-2 border-gray-200 rounded-xl p-6">
                  <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center mb-4">
                    <i className="ri-checkbox-circle-line text-2xl text-orange-600"></i>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-3">Minimum Gereksinimler</h3>
                  <ul className="space-y-2 text-sm text-gray-700">
                    <li className="flex items-start">
                      <i className="ri-arrow-right-s-line text-orange-600 mr-2 mt-0.5"></i>
                      <span>Windows 10 Pro/Enterprise/Education (1903+)</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-arrow-right-s-line text-orange-600 mr-2 mt-0.5"></i>
                      <span>Windows 11 (tüm sürümler)</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-arrow-right-s-line text-orange-600 mr-2 mt-0.5"></i>
                      <span>Internet bağlantısı</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-arrow-right-s-line text-orange-600 mr-2 mt-0.5"></i>
                      <span>Entra ID lisansı</span>
                    </li>
                  </ul>
                </div>

                <div className="bg-white border-2 border-gray-200 rounded-xl p-6">
                  <div className="w-12 h-12 bg-amber-100 rounded-lg flex items-center justify-center mb-4">
                    <i className="ri-star-line text-2xl text-amber-600"></i>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-3">Önerilen Özellikler</h3>
                  <ul className="space-y-2 text-sm text-gray-700">
                    <li className="flex items-start">
                      <i className="ri-arrow-right-s-line text-amber-600 mr-2 mt-0.5"></i>
                      <span>TPM 2.0 (Self-Deploying için zorunlu)</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-arrow-right-s-line text-amber-600 mr-2 mt-0.5"></i>
                      <span>UEFI firmware (Legacy BIOS değil)</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-arrow-right-s-line text-amber-600 mr-2 mt-0.5"></i>
                      <span>Ethernet bağlantısı (Wi-Fi'den daha güvenilir)</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-arrow-right-s-line text-amber-600 mr-2 mt-0.5"></i>
                      <span>OEM Autopilot desteği</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="bg-blue-50 border-l-4 border-blue-500 p-6 rounded-r-xl">
                <div className="flex items-start">
                  <i className="ri-information-line text-2xl text-blue-600 mr-4 mt-1"></i>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-2">OEM Desteği</h4>
                    <p className="text-gray-700 text-sm">
                      Dell, HP, Lenovo, Microsoft Surface gibi büyük üreticiler Autopilot'u doğrudan destekler. Cihaz satın alırken "Autopilot Ready" veya "Windows Autopilot" etiketine dikkat edin.
                    </p>
                  </div>
                </div>
              </div>
            </section>

            {/* Device Registration */}
            <section className="mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Cihaz Kaydı</h2>
              
              <p className="text-gray-700 mb-6">
                Autopilot kullanmak için cihazların donanım kimliklerinin (Hardware Hash) Autopilot servisine kaydedilmesi gerekir.
              </p>

              <div className="space-y-6">
                <div className="bg-white border-2 border-orange-600 rounded-xl p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                    <i className="ri-store-line text-orange-600 mr-3"></i>
                    Yöntem 1: OEM/Distribütör Kaydı (Önerilen)
                  </h3>
                  <p className="text-gray-700 mb-4">
                    Cihazları satın alırken, OEM veya distribütörden doğrudan Autopilot'a kaydetmelerini isteyin. Bu en kolay ve hatasız yöntemdir.
                  </p>
                  <div className="bg-orange-50 rounded-lg p-4">
                    <p className="text-sm text-gray-700">
                      <strong>Avantajlar:</strong> Manuel işlem yok, cihaz elinize ulaşmadan kayıt tamamlanır, hata riski minimum.
                    </p>
                  </div>
                </div>

                <div className="bg-white border-2 border-gray-200 rounded-xl p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                    <i className="ri-terminal-box-line text-amber-600 mr-3"></i>
                    Yöntem 2: Manuel PowerShell Kaydı
                  </h3>
                  <p className="text-gray-700 mb-4">
                    Mevcut cihazları veya OEM desteği olmayan cihazları manuel olarak kaydedin.
                  </p>
                  <div className="bg-gray-900 rounded-lg p-4 overflow-x-auto mb-4">
                    <pre className="text-sm text-gray-100">
{`# 1. Get-WindowsAutopilotInfo scriptini indir
Install-Script -Name Get-WindowsAutopilotInfo

# 2. Hardware Hash'i al ve CSV'ye kaydet
Get-WindowsAutopilotInfo -OutputFile C:\\AutopilotHWID.csv

# 3. CSV'yi Intune'a yükle
# Intune admin center → Devices → Windows → Windows enrollment
# → Devices → Import`}
                    </pre>
                  </div>
                  <div className="bg-amber-50 border-l-4 border-amber-500 p-4 rounded-r-lg">
                    <p className="text-sm text-gray-700">
                      <strong>Not:</strong> Bu yöntem her cihazda ayrı ayrı çalıştırılmalıdır. Büyük dağıtımlar için OEM kaydı tercih edilmelidir.
                    </p>
                  </div>
                </div>

                <div className="bg-white border-2 border-gray-200 rounded-xl p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                    <i className="ri-cloud-line text-red-600 mr-3"></i>
                    Yöntem 3: Microsoft Partner Center
                  </h3>
                  <p className="text-gray-700 mb-4">
                    CSP (Cloud Solution Provider) partnerler, müşteri adına toplu cihaz kaydı yapabilir.
                  </p>
                  <div className="bg-gray-50 rounded-lg p-4">
                    <p className="text-sm text-gray-700">
                      Partner Center → Customers → [Müşteri seç] → Devices → Add devices → CSV yükle
                    </p>
                  </div>
                </div>
              </div>

              <img 
                src="https://readdy.ai/api/search-image?query=IT%20administrator%20registering%20devices%20for%20Autopilot%20deployment%20using%20laptop%20with%20cloud%20connection%20visualization%20modern%20office%20environment%20blue%20teal%20colors%20professional%20setting&width=1200&height=600&seq=device-registration&orientation=landscape"
                alt="Cihaz Kaydı"
                className="w-full h-80 object-cover rounded-xl mt-8"
              />
            </section>

            {/* Profile Configuration */}
            <section className="mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Profil Yapılandırması</h2>
              
              <p className="text-gray-700 mb-6">
                Autopilot profili, cihazın ilk kurulum deneyimini (OOBE - Out-of-Box Experience) özelleştirir.
              </p>

              <div className="bg-gray-900 rounded-xl p-6 mb-6 overflow-x-auto">
                <div className="flex items-center justify-between mb-4">
                  <span className="text-gray-400 text-sm">Örnek: Kurumsal Autopilot Profili</span>
                  <button className="text-teal-400 hover:text-teal-300 text-sm">
                    <i className="ri-file-copy-line mr-1"></i>
                    Kopyala
                  </button>
                </div>
                <pre className="text-sm text-gray-100">
{`{
  "displayName": "Corporate Standard Profile",
  "description": "Tüm kurumsal cihazlar için standart profil",
  "deploymentMode": "UserDriven",
  "joinType": "azureADJoined",
  
  "outOfBoxExperience": {
    // Gizlilik ayarlarını gizle
    "hidePrivacySettings": true,
    
    // EULA'yı gizle (otomatik kabul)
    "hideEULA": true,
    
    // Kullanıcı tipi (standard veya administrator)
    "userType": "standard",
    
    // Klavye seçimini atla
    "skipKeyboardSelection": true,
    
    // Hesap değiştirme seçeneğini gizle
    "hideChangeAccountOpts": true,
    
    // Bölge seçimini atla
    "skipRegionSelection": true,
    
    // Lisans sözleşmesini gizle
    "hideEscapeLink": true
  },
  
  // White Glove'u etkinleştir
  "enableWhiteGlove": false,
  
  // Cihaz adı şablonu
  "deviceNameTemplate": "CORP-%SERIAL%",
  
  // Dil ayarları
  "language": "tr-TR"
}`}
                </pre>
              </div>

              <div className="grid md:grid-cols-2 gap-6">
                <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-xl p-6">
                  <h3 className="text-lg font-bold text-gray-900 mb-4">Kullanıcı Deneyimi Özelleştirmeleri</h3>
                  <ul className="space-y-2 text-sm text-gray-700">
                    <li className="flex items-start">
                      <i className="ri-eye-off-line text-orange-600 mr-2 mt-0.5"></i>
                      <span>Gereksiz OOBE ekranlarını gizle</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-time-line text-orange-600 mr-2 mt-0.5"></i>
                      <span>Kurulum süresini kısalt</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-shield-check-line text-orange-600 mr-2 mt-0.5"></i>
                      <span>Güvenlik ayarlarını zorla</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-user-settings-line text-orange-600 mr-2 mt-0.5"></i>
                      <span>Kullanıcı tipini belirle</span>
                    </li>
                  </ul>
                </div>

                <div className="bg-gradient-to-br from-red-50 to-amber-50 rounded-xl p-6">
                  <h3 className="text-lg font-bold text-gray-900 mb-4">Cihaz Adlandırma</h3>
                  <p className="text-sm text-gray-700 mb-3">
                    Otomatik cihaz adlandırma şablonları kullanarak tutarlı isimlendirme sağlayın:
                  </p>
                  <div className="bg-white rounded-lg p-3 text-sm font-mono text-gray-800 space-y-1">
                    <div>CORP-%SERIAL%</div>
                    <div>WIN-%RAND:5%</div>
                    <div>LAP-%SERIAL:6%</div>
                  </div>
                  <p className="text-xs text-gray-600 mt-2">
                    %SERIAL%: Seri numarası, %RAND:N%: N haneli rastgele
                  </p>
                </div>
              </div>
            </section>

            {/* Enrollment Status Page */}
            <section className="mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Enrollment Status Page (ESP)</h2>
              
              <p className="text-gray-700 mb-6">
                ESP, cihaz kurulumu sırasında kullanıcıya ilerleme durumunu gösterir ve tüm politikalar uygulanana kadar cihazın kullanımını engeller.
              </p>

              <div className="bg-gradient-to-r from-orange-50 to-red-50 rounded-2xl p-8 mb-6">
                <h3 className="text-xl font-bold text-gray-900 mb-4">ESP Aşamaları</h3>
                <div className="space-y-4">
                  <div className="flex items-center">
                    <div className="w-10 h-10 bg-orange-600 text-white rounded-full flex items-center justify-center mr-4 flex-shrink-0 font-bold">
                      1
                    </div>
                    <div className="flex-1">
                      <strong className="text-gray-900">Device Preparation</strong>
                      <p className="text-sm text-gray-600">Cihaz Entra ID'ye katılır ve Intune'a kaydolur</p>
                    </div>
                    <i className="ri-checkbox-circle-fill text-2xl text-green-600"></i>
                  </div>

                  <div className="flex items-center">
                    <div className="w-10 h-10 bg-orange-600 text-white rounded-full flex items-center justify-center mr-4 flex-shrink-0 font-bold">
                      2
                    </div>
                    <div className="flex-1">
                      <strong className="text-gray-900">Device Setup</strong>
                      <p className="text-sm text-gray-600">Cihaz politikaları, sertifikalar ve profiller uygulanır</p>
                    </div>
                    <i className="ri-loader-4-line text-2xl text-orange-600 animate-spin"></i>
                  </div>

                  <div className="flex items-center">
                    <div className="w-10 h-10 bg-gray-300 text-white rounded-full flex items-center justify-center mr-4 flex-shrink-0 font-bold">
                      3
                    </div>
                    <div className="flex-1">
                      <strong className="text-gray-900">Account Setup</strong>
                      <p className="text-sm text-gray-600">Kullanıcı politikaları ve uygulamaları yüklenir</p>
                    </div>
                    <i className="ri-time-line text-2xl text-gray-400"></i>
                  </div>
                </div>
              </div>

              <div className="bg-gray-900 rounded-xl p-6 overflow-x-auto">
                <div className="flex items-center justify-between mb-4">
                  <span className="text-gray-400 text-sm">ESP Yapılandırma Örneği</span>
                </div>
                <pre className="text-sm text-gray-100">
{`{
  "displayName": "Corporate ESP",
  "description": "Kurumsal cihazlar için ESP ayarları",
  
  "blockDeviceSetupUntilComplete": true,
  "allowDeviceResetOnInstallFailure": true,
  "allowLogCollectionOnInstallFailure": true,
  
  "customErrorMessage": "Kurulum sırasında bir sorun oluştu. IT destek ekibi ile iletişime geçin.",
  
  "installProgressTimeoutInMinutes": 60,
  
  "selectedMobileAppIds": [
    "com.microsoft.office.outlook",
    "com.microsoft.teams",
    "com.microsoft.office.word"
  ],
  
  "trackInstallProgressForAutopilotOnly": true,
  "disableUserStatusTrackingAfterFirstUser": false
}`}
                </pre>
              </div>
            </section>

            {/* Troubleshooting */}
            <section className="mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Sorun Giderme</h2>
              
              <div className="space-y-4">
                <div className="bg-white border-2 border-gray-200 rounded-xl p-6">
                  <h3 className="text-lg font-bold text-gray-900 mb-3 flex items-center">
                    <i className="ri-error-warning-line text-red-600 mr-3"></i>
                    Cihaz Autopilot Profilini Görmüyor
                  </h3>
                  <p className="text-gray-700 text-sm mb-3">
                    <strong>Olası Nedenler:</strong>
                  </p>
                  <ul className="text-sm text-gray-700 space-y-1 mb-4">
                    <li>• Cihaz Hardware Hash'i yanlış kaydedilmiş</li>
                    <li>• Profil cihaza atanmamış</li>
                    <li>• Autopilot servisi ile senkronizasyon gecikmesi</li>
                  </ul>
                  <div className="bg-gray-900 rounded-lg p-3">
                    <pre className="text-xs text-gray-100">
{`# Autopilot durumunu kontrol et
Get-AutopilotDiagnostics

# Cihazı Autopilot servisine yeniden kaydet
Get-WindowsAutopilotInfo -Online`}
                    </pre>
                  </div>
                </div>

                <div className="bg-white border-2 border-gray-200 rounded-xl p-6">
                  <h3 className="text-lg font-bold text-gray-900 mb-3 flex items-center">
                    <i className="ri-time-line text-amber-600 mr-3"></i>
                    ESP Çok Uzun Sürüyor
                  </h3>
                  <p className="text-gray-700 text-sm mb-3">
                    <strong>Çözümler:</strong>
                  </p>
                  <ul className="text-sm text-gray-700 space-y-1">
                    <li>• Büyük uygulamaları ESP'den çıkar, kullanıcı oturumunda yükle</li>
                    <li>• Gereksiz politikaları kaldır</li>
                    <li>• Timeout süresini artır</li>
                    <li>• İnternet bağlantısını kontrol et</li>
                  </ul>
                </div>

                <div className="bg-white border-2 border-gray-200 rounded-xl p-6">
                  <h3 className="text-lg font-bold text-gray-900 mb-3 flex items-center">
                    <i className="ri-shield-cross-line text-red-600 mr-3"></i>
                    Entra ID Join Başarısız
                  </h3>
                  <p className="text-gray-700 text-sm mb-3">
                    <strong>Kontrol Edilecekler:</strong>
                  </p>
                  <ul className="text-sm text-gray-700 space-y-1">
                    <li>• Kullanıcının Entra ID lisansı var mı?</li>
                    <li>• Cihaz kayıt limitleri aşılmış mı?</li>
                    <li>• Conditional Access politikaları engelliyor mu?</li>
                    <li>• Ağ bağlantısı ve DNS çözümlemesi çalışıyor mu?</li>
                  </ul>
                </div>
              </div>

              <div className="bg-blue-50 border-l-4 border-blue-500 p-6 rounded-r-xl mt-6">
                <div className="flex items-start">
                  <i className="ri-file-list-line text-2xl text-blue-600 mr-4 mt-1"></i>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-2">Log Dosyaları</h4>
                    <p className="text-gray-700 text-sm mb-2">
                      Detaylı sorun giderme için log dosyalarını inceleyin:
                    </p>
                    <div className="bg-white rounded-lg p-3 text-xs font-mono text-gray-800 space-y-1">
                      <div>C:\Windows\Panther\UnattendGC\</div>
                      <div>C:\Windows\Temp\MDM\</div>
                      <div>Event Viewer → Applications and Services Logs → Microsoft → Windows → Provisioning-Diagnostics-Provider</div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* Best Practices */}
            <section className="mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-6">En İyi Uygulamalar</h2>
              
              <div className="space-y-4">
                <div className="flex items-start bg-white border-2 border-gray-200 rounded-xl p-6">
                  <i className="ri-store-2-line text-2xl text-orange-600 mr-4 mt-1"></i>
                  <div>
                    <strong className="text-gray-900 block mb-2">OEM Kaydını Tercih Edin</strong>
                    <p className="text-gray-700 text-sm">
                      Cihazları satın alırken OEM'den Autopilot kaydı yapmasını isteyin. Bu, manuel işlem yükünü ortadan kaldırır ve hata riskini minimize eder.
                    </p>
                  </div>
                </div>

                <div className="flex items-start bg-white border-2 border-gray-200 rounded-xl p-6">
                  <i className="ri-group-line text-2xl text-orange-600 mr-4 mt-1"></i>
                  <div>
                    <strong className="text-gray-900 block mb-2">Dinamik Gruplar Kullanın</strong>
                    <p className="text-gray-700 text-sm">
                      Autopilot cihazlarını otomatik olarak gruplara eklemek için Entra ID dinamik grupları kullanın. Örnek: (device.devicePhysicalIDs -any _ -contains "[ZTDId]")
                    </p>
                  </div>
                </div>

                <div className="flex items-start bg-white border-2 border-gray-200 rounded-xl p-6">
                  <i className="ri-apps-2-line text-2xl text-orange-600 mr-4 mt-1"></i>
                  <div>
                    <strong className="text-gray-900 block mb-2">Uygulama Dağıtımını Optimize Edin</strong>
                    <p className="text-gray-700 text-sm">
                      Kritik uygulamaları ESP'de yükleyin, büyük uygulamaları kullanıcı oturumunda arka planda yükleyin. Bu, kullanıcı deneyimini iyileştirir.
                    </p>
                  </div>
                </div>

                <div className="flex items-start bg-white border-2 border-gray-200 rounded-xl p-6">
                  <i className="ri-test-tube-line text-2xl text-orange-600 mr-4 mt-1"></i>
                  <div>
                    <strong className="text-gray-900 block mb-2">Test Ortamı Oluşturun</strong>
                    <p className="text-gray-700 text-sm">
                      Yeni profilleri ve politikaları önce test cihazlarında deneyin. Üretim ortamına geçmeden önce tüm senaryoları test edin.
                    </p>
                  </div>
                </div>

                <div className="flex items-start bg-white border-2 border-gray-200 rounded-xl p-6">
                  <i className="ri-book-open-line text-2xl text-orange-600 mr-4 mt-1"></i>
                  <div>
                    <strong className="text-gray-900 block mb-2">Kullanıcı Dokümantasyonu</strong>
                    <p className="text-gray-700 text-sm">
                      Kullanıcılar için basit kurulum kılavuzu hazırlayın. İlk açılış deneyimini ve beklenen süreyi açıklayın.
                    </p>
                  </div>
                </div>
              </div>
            </section>

            {/* Related Articles */}
            <section className="mt-16 pt-12 border-t-2 border-gray-200">
              <h2 className="text-2xl font-bold text-gray-900 mb-6">İlgili Makaleler</h2>
              <div className="grid md:grid-cols-2 gap-6">
                <Link 
                  to="/intune/modern-cihaz-yonetimi"
                  className="group bg-white border-2 border-gray-200 rounded-xl p-6 hover:border-orange-600 transition-all"
                >
                  <h3 className="text-lg font-bold text-gray-900 mb-2 group-hover:text-orange-600 transition-colors">
                    Modern Cihaz Yönetimi
                  </h3>
                  <p className="text-gray-600 text-sm mb-4">
                    Intune ile endpoint güvenliği ve MDM/MAM farkları
                  </p>
                  <span className="text-orange-600 text-sm font-medium">
                    Devamını Oku <i className="ri-arrow-right-line ml-1"></i>
                  </span>
                </Link>

                <Link 
                  to="/intune/uygulama-koruma-politikalari"
                  className="group bg-white border-2 border-gray-200 rounded-xl p-6 hover:border-orange-600 transition-all"
                >
                  <h3 className="text-lg font-bold text-gray-900 mb-2 group-hover:text-orange-600 transition-colors">
                    Uygulama Koruma Politikaları
                  </h3>
                  <p className="text-gray-600 text-sm mb-4">
                    MAM politikaları ile BYOD senaryolarında veri güvenliğini sağlama
                  </p>
                  <span className="text-orange-600 text-sm font-medium">
                    Devamını Oku <i className="ri-arrow-right-line ml-1"></i>
                  </span>
                </Link>
              </div>
            </section>

          </div>
        </div>
      </article>

      <Footer />
    </div>
  );
}
